const sites = [
  {
    id: 1029019178,
    provisioning_id: null,
    plan_id: 765414191,
    planId: 765414191,
    feature_definition_key: 'wordpress_site',
    status: 'active',
    statusDomain: true,
    ssl: 'active',
    domain: 'wp1029019178.wordpress-locaweb.ws',
    wordpress_id: 'c84856ccf966c73f3fd8ce32a721e01f3ebab66e',
    cdn: false,
    created_at: '2022-08-12T06:40:48.191-03:00'
  },
  {
    id: 1027855172,
    provisioning_id: null,
    plan_id: 765414191,
    planId: 765414191,
    feature_definition_key: 'wordpress_site',
    status: 'activating',
    statusDomain: false,
    ssl: null,
    domain: 'qalwwpnorm2.com.br',
    wordpress_id: '67a92ba39009e5e71faea16cb8b5a5d04248f119',
    cdn: false,
    created_at: '2021-02-24T10:54:48.860-03:00'
  },
  {
    id: 1020627893,
    provisioning_id: null,
    plan_id: 764515112,
    feature_definition_key: 'wordpress_site',
    status: 'active',
    statusDomain: false,
    ssl: 'deactivated',
    domain: 'drampa.alves.website',
    wordpress_id: '578a48f01707543f9e3a573184d063fedb7f8258',
    cdn: false,
    created_at: '2022-11-07T09:41:04.336-03:00'
  },
  {
    id: 1020627572,
    provisioning_id: null,
    plan_id: 764515112,
    feature_definition_key: 'wordpress_site',
    status: 'active',
    statusDomain: true,
    ssl: 'deactivated',
    domain: 'gothita.alves.website',
    wordpress_id: 'db00778ac0f0ad67acd762367beababd9c6d4364',
    cdn: true,
    created_at: '2022-10-24T11:46:22.772-03:00'
  },
  {
    id: 1020623171,
    provisioning_id: null,
    plan_id: 764515112,
    feature_definition_key: 'wordpress_site',
    status: 'active',
    statusDomain: true,
    ssl: 'active',
    domain: 'dewott.com.br',
    wordpress_id: '110b4ba666924ef4be479e570e398af55a22c50c',
    cdn: false,
    created_at: '2022-07-07T11:01:48.133-03:00'
  }
]
export default (server) => {
  sites.forEach(site => {
    server.create('site', site)
  })
}
